<div class="detail-row" [class.detail-row--wrap]="wrapValue">
  @if (icon) {
  <ion-icon [name]="icon" class="detail-icon" aria-hidden="true" />
  }
  <span class="detail-label">{{ label }}</span>
  <span class="detail-value">{{ value }}</span>
</div>
